module.exports = __webpack_public_path__ + "img/Klipsu-IV.047570fc.png";